import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants";

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  credentials: "include",
});

export const apiSlice = createApi({
  baseQuery,
  tagTypes: ["Product", "Products", "User", "Users", "Order", "Orders", "ExchangeRate"],
  endpoints: (builder) => ({}),
});

export default apiSlice.reducer;
